export default function ({ $axios, $sentry }) {
  const maxRetries = 2
  const retryDelay = 500

  $axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const config = error.config

      if (!config.__retryCount) {
        config.__retryCount = 0
      }

      if (config.__retryCount >= maxRetries) {
        $sentry.captureException(error)
        return Promise.reject(error)
      }

      config.__retryCount += 1

      // eslint-disable-next-line no-console
      console.warn(`Retrying request ${config.__retryCount}...`)

      await new Promise((resolve) => setTimeout(resolve, retryDelay))

      return $axios(config)
    }
  )
}
